import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copy .env.example to .env and fill them in.',
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // The magic link comes back as a hash fragment; letting the client consume
    // it on load is what turns the click into a session.
    detectSessionInUrl: true,
    // Not 'pkce'. A PKCE code exchange needs a code_verifier the browser that
    // requested the link generated and stored — which is exactly what a link
    // minted out-of-band (the PR preview workflow's `admin/generate_link`
    // call, run from a GitHub Action with no browser at all) cannot supply.
    // Those links are always implicit-grant (`#access_token=…`), and with
    // flowType 'pkce' the client throws on one rather than accepting it,
    // silently leaving the visitor on the sign-in screen with a valid token
    // sitting unused in the URL. 'implicit' is also what the comment above
    // already assumed was happening.
    flowType: 'implicit',
  },
  realtime: {
    // Fast enough to feel immediate, slow enough that a busy routine reporting
    // every few seconds cannot saturate the socket.
    params: { eventsPerSecond: 20 },
  },
});

/** Where the edge functions live. Derived from the project URL unless overridden. */
export const functionsUrl: string =
  import.meta.env.VITE_FUNCTIONS_URL?.replace(/\/+$/, '') ??
  `${url.replace(/\/+$/, '')}/functions/v1`;
